<!--单位概况-->
<template>
	<div class="userPowerUnit">
          <lightBlueusePowerUnit v-if='skinName=="科技蓝"'/>
          <navyUsePowerUnit v-else/>
	</div>
</template>

<script>
	import lightBlueusePowerUnit from '@/page/unitProfile/lightBlueusePowerUnit/usePowerUnit.vue'//浅蓝色
	import navyUsePowerUnit from '@/page/unitProfile/navyUsePowerUnit/usePowerUnit.vue'//深蓝色
	export default {
		components: {
			lightBlueusePowerUnit,
			navyUsePowerUnit,
		},
		props: {},
		data() {
			return {
				
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {},
		computed: {
			skinName(){
				return this.$store.resourcesStore.state.nowSkinObject.skinName
			}
		},
		watch: {},
		methods: {

		}
	}
</script>

<style scoped>

</style>
